export const YearlyEvent = {
    TURNINGPOINT: "TURNING POINT",
    AUTUMINKOREA: "AUTUMN IN KOREA",
    MAGICALMUSICSOUNDTRACT: "MAGICAL MUSIC SOUNDTRACK",
    CLASSICALFESTIVALSBY: "CLASSICAL FESTIVAL SBY - SERIES 1",
    CLASSICALFESTIVALJKT: "CLASSICAL FESTIVAL JKT - SERIES 2",
    CHRISTMASWONDERLAND: "CHRISTMAS WONDERLAND",
    MASTERCLASS: "MASTERCLASS",
    CLASSICALFESTIVALJKT2024: "CLASSICAL FESTIVAL JKT - SERIES 3",
    APCSTHESOUNDOFASIA2025: "CLASSICAL THE SOUND OF ASIA 2025",
}

export const ListEvent = [
    {
        title: YearlyEvent.APCSTHESOUNDOFASIA2025,
        year: "2025"
    },
    {
        title: YearlyEvent.CLASSICALFESTIVALJKT2024,
        year: "2024"
    },
    {
        title: YearlyEvent.MASTERCLASS,
        year: "2023"
    },
    {
        title: YearlyEvent.CHRISTMASWONDERLAND,
        year: "2023"
    },
    {
        title: YearlyEvent.CLASSICALFESTIVALJKT,
        year: "2023"
    },
    {
        title: YearlyEvent.CLASSICALFESTIVALSBY,
        year: "2023"
    },
    {
        title: YearlyEvent.MAGICALMUSICSOUNDTRACT,
        year: "2022"
    },
    {
        title: YearlyEvent.AUTUMINKOREA,
        year: "2020"
    },
    {
        title: YearlyEvent.TURNINGPOINT,
        year: "2019"
    },
]

